import {useState,useEffect} from 'react'
import {useSelector,useDispatch} from 'react-redux'

import {
	selectMemberPrivateRoomId,
	getChatRoom,
	setShow as setShowMessageCenter
} from '../MessageCenter/messageCenterSlice'

import useCurrentUser from '../../hooks/useCurrentUser'

import Spinner from 'react-bootstrap/Spinner'
import Button from 'react-bootstrap/Button'

import {Link} from 'react-router-dom'

import TodaysEvents from '../todaysEvents/TodaysEvents'

import {envAwarePost} from '../../util/util'
import YoutubeModal from '../YoutubeModal/YoutubeModal'
import {addZero} from '../../util/datetime'

const OnDemand = ({videos})=>{
	console.log(videos)
	const [showVideoModal,setShowVideoModal] = useState(false)
	const [videoModalUrl,setVideoModalUrl] = useState('')
	const [videoModalDescription,setVideoModalDescription] = useState('')
	const [videoModalTitle,setVideoModalTitle] = useState('')
	return (
		<div className="p-3">
			<div style={{
				textAlign:'center',
				fontSize:'20px',
				fontWeight:'600',
				margin:'16px auto'
			}}>
				On Demand
			</div>
			<div>
				{videos.map(({name,description,url,time,id,youtube_thumbnail})=>(
					<div 
						style={{cursor:'pointer'}}
						onClick={()=>{
							setVideoModalUrl(url)
							setVideoModalTitle(name)
							setVideoModalDescription(description)
							setShowVideoModal(true)
						}}
						key={id} 
						className="mt-2 rounded border d-flex overflow-hidden"
					>
						{Boolean(youtube_thumbnail)&&
							<div 
								className="position-relative" 
								onClick={()=>{
									setVideoModalUrl(url)
									setVideoModalTitle(name)
									setVideoModalDescription(description)
									setShowVideoModal(true)
								}}
							>
								<img 
									src={youtube_thumbnail}
									style={{
										cursor:'pointer',
										width:'80px',
										height:'80px',
										objectFit:'cover',
										display:'block',
										marginRight:'8px',
										flex:'0 0 auto'
									}}
								/>
								<i 
									className="fa fa-play text-white bg-dark rounded p-1"
									style={{
										transform:'translate(-50%,-50%)',
										position:'absolute',
										top:'50%',
										left:'50%',
										cursor:'pointer'
									}}
								/>
							</div>
						}
						<div className="w-100 p-2">
							<div className="d-flex justify-content-between">
								<div
									style={{cursor:'pointer'}}
									onClick={()=>{
										setVideoModalUrl(url)
										setVideoModalDescription(description)
										setShowVideoModal(true)
										setVideoModalTitle(name)
									}}
									className="text-primary"
									variant="link"
								>
									{Boolean(name)?name:'Untitled Video'} ({time.split(':').slice(1).map(addZero).join(':')})
								</div>
							</div>
							<div>
								{description}
							</div>
						</div>
					</div>
				))}
			</div>
			<YoutubeModal
				title={videoModalTitle}
				description={videoModalDescription}
				waiver="By watching and following along with this fitness/health video, you acknowledge that you are voluntarily participating in physical activity, which may include strenuous exercise and movement. You understand and acknowledge that there are risks associated with physical activity and exercise, including the risk of serious injury or death. You further acknowledge that you have consulted with your personal trainer or healthcare provider before participating in this video and have received clearance to do so. You hereby release and waive any claims against the video provider for any injuries or damages that may occur as a result of your participation in the video. By continuing to watch and follow along with the video, you agree to the terms of this waiver."
				demoVideo={videoModalUrl} 
				demoVideoShow={showVideoModal} 
				setDemoVideoShow={setShowVideoModal}
				playing={false}
				loop={false}
			/>
		</div>
	)
}

const DynamicDashboard = ()=>{
	const [isLoading,setIsLoading] = useState(false)
	const [components,setComponents] = useState([])
	useEffect(()=>{
		setIsLoading(true)
		envAwarePost('api/init/',{action:'getDashboard',platform:'web'})
			.then(res=>{
				setIsLoading(false)
				setComponents(res.data.dashboard)
			})
	},[])

	return (
		<div>
			{isLoading&&
				<div className="d-flex justify-content-center p-5">
					<Spinner animation="border"/>
				</div>
			}
			{!isLoading&&components.map(component=>{
				switch(component.key){
					case 'on_demand_videos': return <OnDemand videos={component.component_data}/>
					default: return null
				}
			})}
		</div>
	)
}

export default function ProspectDashboard() {
	const dispatch = useDispatch()
	const trainer_id = useSelector(state=>state.users.current_user.trainer_data?.trainer_id)
	const room_id = useSelector(state=>selectMemberPrivateRoomId(state,trainer_id))

	const user = useCurrentUser()

	const acquisitionText = (()=>{
		switch(user.bio_data.acquisition_type){
			case "message": return ' sent the following message:'
			case "incomplete_purchase": return ' attempted the following purchase:'
			case "completed_purchase": return ' completed the following purchase:'
			case "form": return ' completed the following intake form:'
			case "manual": return ' were manually added by this trainer.'
		}
	})()

	console.log(user)

	const handleChat = ()=>{
		dispatch(setShowMessageCenter(true))
		dispatch(getChatRoom({room_id}))
	}
	return (
		<div>
			<TodaysEvents/>
			<DynamicDashboard/>
			<div className="p-2 p-md-5">
				<Button 
					onClick={handleChat}
					block 
					variant="outline-success"
				>
					<i className="fa fa-comment"/> Chat with your potential trainer
				</Button>
				<small className="my-2 d-block text-muted text-center">or</small>
				<Button 
					to="/profile"
					as={Link}
					block 
					variant="outline-dark"
				>
					<i className="fa fa-user"/> Edit your profile
				</Button>
				<hr className="mt-4 mb-2"/>
				<div>
					Your account was created when you {acquisitionText}
				</div>
				{(user.account_type!=='prospect' || user.bio_data.acquisition_type!=='manual')&&
					<div>
						 {user.bio_data.acquisition_data}
					</div>
				}
			</div>
		</div>
	)
}